module.exports = __webpack_public_path__ + "img/ios.9eafdb23.png";